<section class="outbound-api-section">
    <h2 class="section-title">{{ 'aumico_outbound_api_section_title' | i18next }}</h2>
    <p class="section-description">{{ 'aumico_outbound_api_section_description' | i18next }}</p>

    <div class="cards-grid">
        <aumico-vendor-integration-card
            *ngFor="let client of clients$ | async; trackBy: trackByClientId"
            [vendor]="cardView(client)"
            [badgeKey]="client.status === 'revoked' ? 'aumico_outbound_api_status_revoked' : null"
            badgeVariant="danger"
            (infoClick)="onInfo(client)"
        ></aumico-vendor-integration-card>

        <button class="create-card" type="button" data-testid="outbound-client-create" (click)="onCreate()">
            <span class="create-card__plus">+</span>
            <span class="create-card__label">{{ 'aumico_outbound_api_create_button' | i18next }}</span>
        </button>
    </div>
</section>

<aumico-partner-client-create-modal
    *ngIf="createModalOpen"
    (closed)="onModalsClosed()"
></aumico-partner-client-create-modal>

<aumico-partner-client-info-modal
    *ngIf="infoClient != null"
    [client]="infoClient"
    (closed)="onModalsClosed()"
></aumico-partner-client-info-modal>
